import { useMemo } from 'react';

const useApplePayAvailable = (): boolean =>
  useMemo(() => {
    try {
      return Boolean(window.ApplePaySession?.canMakePayments());
    } catch {
      return false;
    }
  }, []);

export default useApplePayAvailable;
